<template>
  <div class="main-page">
    <v-progress-linear
      v-show="is_loading"
      absolute
      indeterminate
      height="3"
    ></v-progress-linear>

    <template v-if="is_loading">
<!--      До загрузки маршрутов нет возможности проверить корректность избранных маршрутов-->
      <h3 class="total-center" style="width: 90%;">
        Зачекайте, будь ласка.<br>
        Відбувається завантаження даних...
      </h3>
    </template>
    <template v-else>
      <c-rect-wrapper/>

      <c-welcome-block v-show="rect_count == 0">
        <c-rect-create>
          <v-btn dark :color="colors.dark">
            <v-icon class="mr-2">mdi-arrow-decision-outline</v-icon>
            Додати карту
          </v-btn>
        </c-rect-create>
      </c-welcome-block>
    </template>
  </div>
</template>

<script>
import cWelcomeBlock from '@/components/base/c-welcome-block'
import cRectWrapper from '@/components/rect/c-rect-wrapper'
import cRectCreate from '@/components/rect/c-rect-create'
import { colors } from '@/helpers/base/colors'
export default {
  name: 'main-page',
  metaInfo: {
    title: 'Головна | Transport Map'
  },
  components: {
    cRectWrapper,
    cWelcomeBlock,
    cRectCreate
  },
  data() {
    return {
      is_loading: true,
      colors: { ...colors }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    rect_count() {
      return this.$store.getters.RECT_LIST.length
    }
  },
  methods: {
    fetchQueue() {
      this.is_loading = true
      let array = [
        this.$store.dispatch('ROUTES_REQUEST'),
        this.$store.dispatch('ROUTES_TYPE_REQUEST'),
        // this.$store.dispatch('STOPS_REQUEST')
      ]
      Promise.all(array)
      .finally(() => this.is_loading = false)
    },
    fetchData() {
      // Получаем инфу о пользователе и потом все остальное
      this.$store.dispatch('AUTH_USER_REQUEST')
      .then(() => this.fetchQueue())
      .catch((error) => {
        // Если ошибка не 401, тогда хрен с тем пользователем, загружаем данные дальше (временно, пока у юзеров нет групп и прав)
        if(error.response && error.response.status && error.response.status !== 401) {
          this.fetchQueue()
        } else {
          // Если ошибка 401, тогда показываем форму авторизации
          this.$router.go()
        }
      })

      // Сделано так для того, чтобы в случае ошибки 401 не требовало авторизацию для каждого запроса в fetchQueue() и на будущее, если у пользователей будут группы и права
    }
  }
}
</script>

<style lang="scss">
  .main-page {
    width: 100%;
    height: 100%;
    min-height: calc(100vh - 25px);
  }
  .total-center {
    text-align: center;
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

</style>